'use strict'

Object.defineProperty(exports, '__esModule', {
  value: true
})

var _jsCookie = require('js-cookie')

var _jsCookie2 = _interopRequireDefault(_jsCookie)

var _md = require('md5')

var _md2 = _interopRequireDefault(_md)

var _axios = require('axios')

var _axios2 = _interopRequireDefault(_axios)

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj } }

// 创建axios实例
var ajax = _axios2.default.create({
  timeout: 10000, // 请求超时时间 10s
  withCredentials: true // 允许跨域传递 cookie
})

var getEntranceUrl = function getEntranceUrl() {
  // var hostname = window.location.hostname
  // var temp = hostname.split('.')
  // temp.splice(0, 1, process.env.VUE_APP_PORTAL)
  // return '//' + temp.join('.')
  return 'https://'+location.host;
}

var getLgnUrl = function getLgnUrl() {
  var hostname = window.location.hostname
  var temp = hostname.split('.')
  // temp.splice(0, 1, 'lgn')
  return '//' + temp.join('.')
}

var redirectToLogin = function redirectToLogin() {
  var entranceUrl = getEntranceUrl()
  var encodedHref = encodeURIComponent(window.location.href)
  window.location.replace(entranceUrl + '#/?redirect=' + encodedHref)
  setTimeout(function () {
    window.location.reload(true)
  }, 300)
}

var redirectToAuthorization = function redirectToAuthorization(platformName) {
  var permissionType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1
  var isExtUser = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false

  var entranceUrl = getEntranceUrl()
  var redirect = entranceUrl + '/#/authorization'
  if (platformName && platformName.length > 1) {
    redirect += '?platform=' + platformName + '&permissionType=' + permissionType + '&isExtUser=' + isExtUser
  } else {
    redirect += '?permissionType=' + permissionType + '&isExtUser=' + isExtUser
  }

  window.locationDirect(redirect);
}

var userMenusfilter = function userMenusfilter(routes, userStatus) {
  // 传入的routes非数组直接返回空
  if (!Array.isArray(routes)) {
    return []
  }

  // 超级管理员，拥有全部路由权限
  if (userStatus.root) {
    return routes
  }

  // 未配置菜单权限
  if (!userStatus.menus) {
    return []
  }

  var allPathArr = userStatus.menus.map(function (item) {
    return item.path
  })

  var userMenus = []

  // 路由过滤
  routes.forEach(function (routeItem) {
    if (!routeItem.children) {
      if (routeItem.meta && routeItem.meta.needAuth) {
        if (allPathArr.includes(routeItem.path)) {
          userMenus.push(routeItem)
        }
      } else {
        userMenus.push(routeItem)
      }
    } else {
      var filterChild = routeItem.children.filter(function (childItem) {
        var curPath = routeItem.path + '/' + childItem.path
        return allPathArr.includes(curPath)
      })

      if (filterChild.length > 0) {
        routeItem.children = filterChild
        userMenus.push(routeItem)
      }
    }
  })

  return userMenus
}

var refreshToken = function refreshToken(gap) {
  // 刷新登录态的间隔时间（单位：毫秒）默认15分钟=15*60*1000
  var gapTime = gap || 900000

  if (checkGap(gapTime)) {
    var commitData = {
      client_id: 'xp_entrance',
      device_id: getDeviceId(),
      timestamp: new Date().getTime()
    }
    commitData.nonce = (0, _md2.default)(~~(Math.random() * 100000))
    commitData.sign = (0, _md2.default)(commitData.client_id + 'device_id' + commitData.device_id + 'nonce' + commitData.nonce + 'timestamp' + commitData.timestamp)

    var reqUrl = getLgnUrl() + '/api/lgn/oauth/token/renew/frontend'

    ajax.get(reqUrl, {
      params: commitData
    }).then(function (res) {
      if (res.code !== 200) {
        console.log(res)
      }
    }).catch(function (err) {
      console.log(err)
    })
  }
}

var getDeviceId = function getDeviceId() {
  if (_jsCookie2.default.get('deviceId')) {
    return _jsCookie2.default.get('deviceId')
  } else {
    var str = (0, _md2.default)(~~(Math.random() * 100000))
    _jsCookie2.default.set('deviceId', str, 30)
    return str
  }
}

var checkGap = function checkGap(gapTime) {
  var nowTime = new Date().getTime()
  var lastTime = _jsCookie2.default.get('freshTime')
  if (lastTime) {
    if (nowTime - lastTime > gapTime) {
      _jsCookie2.default.set('freshTime', nowTime)
      return true
    } else {
      return false
    }
  } else {
    _jsCookie2.default.set('freshTime', nowTime)
    return true
  }
}

exports.default = {
  redirectToLogin: redirectToLogin,
  redirectToAuthorization: redirectToAuthorization,
  userMenusfilter: userMenusfilter,
  refreshToken: refreshToken
}
